"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function VoiceAgentFAQ({ heading, items }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-24 border-t border-white/[0.06]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12 text-center"
        >
          <p className="text-sm font-semibold text-violet-400 uppercase tracking-widest mb-3">
            FAQ
          </p>
          <h2 className="text-3xl lg:text-4xl font-bold text-white">{heading}</h2>
        </motion.div>

        <div className="space-y-3">
          {items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full text-left rounded-2xl bg-zinc-900 border border-white/[0.08] hover:border-violet-500/20 px-6 py-5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-500/50"
                aria-expanded={openIndex === i}
              >
                <div className="flex items-center justify-between gap-4">
                  <span className="text-base font-semibold text-white leading-snug">
                    {item.question}
                  </span>
                  <span
                    className={`flex-shrink-0 w-6 h-6 rounded-full border flex items-center justify-center transition-colors ${
                      openIndex === i
                        ? "border-violet-500/40 text-violet-400 bg-violet-500/10"
                        : "border-white/10 text-zinc-500"
                    }`}
                  >
                    <svg
                      className={`w-3 h-3 transition-transform duration-200 ${
                        openIndex === i ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2.5}
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                  </span>
                </div>
              </button>

              <AnimatePresence initial={false}>
                {openIndex === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25, ease: "easeInOut" }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-5 pt-3 text-zinc-400 text-sm leading-relaxed border-x border-b border-white/[0.08] rounded-b-2xl bg-zinc-900/60 -mt-2">
                      {item.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
